import { render } from "./TimeSlotsPage.vue?vue&type=template&id=2c9e2968&scoped=true&ts=true"
import script from "./TimeSlotsPage.ts?vue&type=script&lang=ts"
export * from "./TimeSlotsPage.ts?vue&type=script&lang=ts"

import "./TimeSlotsPage.vue?vue&type=style&index=0&id=2c9e2968&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9e2968"]])

export default __exports__